import { cn } from "@/lib/utils";
import { SectionLabel } from "@/components/ui/section-label";
import { PopoverRow } from "@/components/ui/popover-row";
import { POPOVER_SURFACE_CLASSES } from "@/lib/surface-styles";
import type { SlashCommand } from "./slash-commands";

export { type SlashCommand, SLASH_COMMANDS } from "./slash-commands";

interface SlashCommandPopoverProps {
  commands: SlashCommand[];
  onSelect: (command: SlashCommand) => void;
  selectedIndex: number;
}

export function SlashCommandPopover({
  commands,
  onSelect,
  selectedIndex,
}: SlashCommandPopoverProps) {
  if (commands.length === 0) return null;

  return (
    <div className={cn(POPOVER_SURFACE_CLASSES, "w-72")}>
      <div className="border-b border-border px-3 py-1.5">
        <SectionLabel variant="menu">Commands</SectionLabel>
      </div>
      {commands.map((cmd, i) => {
        const Icon = cmd.icon;
        return (
          <PopoverRow
            key={cmd.command}
            isSelected={i === selectedIndex}
            className="gap-3"
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect(cmd);
            }}
          >
            <div
              className="flex h-7 w-7 shrink-0 items-center justify-center rounded"
              style={{ backgroundColor: cmd.color + "15" }}
            >
              <Icon size={16} weight="Bold" style={{ color: cmd.color }} />
            </div>
            <div className="min-w-0 text-left">
              <div className="text-[13px] font-medium text-foreground">
                /{cmd.command}
              </div>
              <div className="truncate text-[11px] text-muted-foreground">
                {cmd.description}
              </div>
            </div>
          </PopoverRow>
        );
      })}
    </div>
  );
}
